export default __webpack_public_path__ + "static/media/reviewing-your-work.fc23b33e.gif";